import { useState } from 'react';

function FeeTabs({
  baseCurrency,
  cryptoCurrency,
  setFeeDisplayType,
}: {
  baseCurrency: string;
  cryptoCurrency?: string;
  setFeeDisplayType: (_type: 'crypto' | 'usd') => void;
}): JSX.Element {
  const [isUsd, setIsUsd] = useState(false);

  return (
    <div
      className="text-textTertiary cursor-pointer"
      onClick={() => {
        setFeeDisplayType(isUsd ? 'crypto' : 'usd');
        setIsUsd(!isUsd);
      }}
    >
      <button
        type="button"
        className={`font-bold ${
          isUsd ? 'border-none hover:text-primary' : 'border-b-4 border-primary text-textParagraph'
        } mr-4`}
        data-testid="cryptoTitle"
      >
        {cryptoCurrency}
      </button>

      <button
        type="button"
        className={`font-bold ${
          !isUsd ? 'border-none hover:text-primary' : 'border-b-4 border-primary text-textParagraph'
        }`}
        data-testid="baseCurrencyTitle"
      >
        {baseCurrency}
      </button>
    </div>
  );
}

FeeTabs.defaultProps = {
  cryptoCurrency: undefined,
  showCryptoTab: false,
};

export default FeeTabs;
